import Request from './request';
import i18n from '@/i18n'
import store from '@/store.js';
import snackbar from '@/plugins/snackbar';

async function fetch(data) {
    return Request('get', "api/production-plans", data);
}

async function getProductionMaterials(data) {
    return Request('get', "api/production-plans/get-production-materials/", data);
}

async function getProductionMaterialDetails(data) {
    return Request('get', "api/production-plans/get-add-item/", data);
}

async function addPreview(data) {
    return Request('post', "api/production-plans/add-view/", data);
}

async function add(data) {
    return Request('post', "api/production-plans/add/", data);
}

async function editPreview(data) {
    return Request('post', "api/production-plans/edit-view/", data);
}

async function edit(data) {
    return Request('post', "api/production-plans/edit/", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/production-plans/view/?id=" + id , data);
}

async function cancel(id) {
    return Request('get', "api/production-plans/cancel/" + id);
}

async function autoSplitProduction(data) {
    return Request('get', "api/production-plans/auto-split-stock-ins/" , data);
}

async function addAutoSplitProduction(data) {
    return Request('post', "api/production-plans/auto-split-view/" , data);
}

// 导出生产计划
async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/production-plans/export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

export default {
    fetch,
    getProductionMaterials,
    getProductionMaterialDetails,
    addPreview,
    add,
    editPreview,
    edit,
    fetchOne,
    cancel,
    autoSplitProduction,
    addAutoSplitProduction,
    exports,
};